import nlJson from '../../lang/nl.json';
export function setSegmentMarkers(segment, title) {
    const unplayableClass = 'seekbar-marker-unplayable';
    const unplayableTitle = nlJson['segment.unplayableTitle'];
    const ONE_DAY_IN_SECONDS = 86400;
    return [
        {
            time: 0,
            duration: segment.inpoint,
            title: unplayableTitle,
            cssClasses: [unplayableClass]
        },
        {
            time: segment.inpoint,
            duration: segment.outpoint - segment.inpoint,
            title: title
        },
        {
            time: segment.outpoint,
            duration: ONE_DAY_IN_SECONDS,
            title: unplayableTitle,
            cssClasses: [unplayableClass]
        }
    ];
}
